import { ExpandMore } from "@material-ui/icons";
import React, { useEffect, useRef } from "react";

type Props = {
    title: string | JSX.Element;
    filterApplied?: boolean;
    styles?: React.CSSProperties;
    contentStyles?: React.CSSProperties;
    buttonStyles?: React.CSSProperties;
};

const Dropdown: React.FC<Props> = (props) => {
    const ref = useRef<HTMLDivElement>(null);

    function handleDrop(e: any) {
        e.stopPropagation();
        const close = ref.current?.classList.contains("show");
        document.querySelectorAll("#dropdown").forEach(e => e.classList.remove("show"));
        if (!close)
        ref.current?.classList.add("show");
    }

    function closeAllDropDown(e: MouseEvent) {
        if (!ref.current?.contains(e.target as Node) && ref.current !== e.target)
        document
            .querySelectorAll("#dropdown")
            .forEach((e) => e.classList.remove("show"));
    }

    useEffect(() => {
        document.addEventListener("click", closeAllDropDown);

        return () => document.removeEventListener("click", closeAllDropDown);
    }, []);
    
    return (
        <div style={props.styles ?? {}} className="dropdown">
            <button
                onClick={handleDrop}
                className={props.filterApplied ? "dropbtn filter__applied" : "dropbtn"}
                style={props.buttonStyles ?? {}}
            >
                {props.title} <ExpandMore />
                {/* {props.filterApplied && <div className="green_dot" />} */}
            </button>
            <div
                id="dropdown"
                ref={ref}
                className="dropdown-wrapper pt_0"
            >
                <div className="dropdown-content" style={props.contentStyles ?? {}}>
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default Dropdown;
